const initialState = {
  phases: [],
  tasks: [],
};

const ProjectPlanning = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROJECT_PLANNING':
      return {
        phases: action.phases || [],
        tasks:  action.tasks  || [],
      };
    default:
      return state;
  }
};

export default ProjectPlanning;
